import React from 'react';
import { useTranslation } from 'react-i18next';

import './plan-upgrade-alert.css';

export interface PlanUpgradeAlertProps {
  message: string;
  /** Shown under the message when the error requires a Family plan upgrade. */
  upgradeHint?: string | null;
  onDismiss?: () => void;
  className?: string;
}

/**
 * Form/screen alert for plan limits and feature gates — message plus optional upgrade next-step.
 */
const PlanUpgradeAlert: React.FC<PlanUpgradeAlertProps> = ({ message, upgradeHint = null, onDismiss, className }) => {
  const { t } = useTranslation('forms');
  return (
    <div className={`plan-upgrade-alert${className ? ` ${className}` : ''}`} role="alert">
      <div className="plan-upgrade-alert__body">
        <p className="plan-upgrade-alert__message">{message}</p>
        {upgradeHint ? <p className="plan-upgrade-alert__hint">{upgradeHint}</p> : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          className="plan-upgrade-alert__dismiss"
          onClick={onDismiss}
          aria-label={t('actions.dismiss')}
        >
          ×
        </button>
      ) : null}
    </div>
  );
};

export default PlanUpgradeAlert;
